var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.6133,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22178 22.6719H11.3059V12.6875H8.22178V22.6719Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94141 9.5C7.94141 10.4844 8.7358 11.2813 9.76384 11.2813C10.7451 11.2813 11.5395 10.4844 11.5395 9.5C11.5395 8.51563 10.7451 7.67188 9.76384 7.67188C8.7358 7.67188 7.94141 8.51563 7.94141 9.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8106 22.6719H22.9414V17.1875C22.9414 14.5156 22.3339 12.4062 19.2031 12.4062C17.7078 12.4062 16.6797 13.25 16.2592 14.0469H16.2124V12.6875H13.2685V22.6719H16.3526V17.75C16.3526 16.4375 16.5863 15.1719 18.2218 15.1719C19.8106 15.1719 19.8106 16.6719 19.8106 17.7969V22.6719Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdien);
export default __webpack_public_path__ + "static/media/linkdien.a2b0cfa6ec6fd94fed7b12b61fc66443.svg";
export { ForwardRef as ReactComponent };